import { jsxs as g, jsx as i } from "react/jsx-runtime";
import * as n from "react";
import { useState as G, useId as L, useEffect as M } from "react";
import { W as j } from "../index-D6IbTb4M.js";
import { u as z } from "../index-DoOsnuB6.js";
import { P as I, c as A } from "../index-D8UDu4KA.js";
import { a as K, c as R } from "../index-eoE_jzLb.js";
import { u as q } from "../index-BZPx6jYI.js";
import { u as T } from "../index-4vbonZJj.js";
import { P as X } from "../index-CRtCLpV2.js";
import { c as S } from "../clsx-OuTLNxxd.js";
import { L as F } from "../Label-B9Ttm_DE.js";
import '../Checkbox.css';var w = "Checkbox", [W] = A(w), [$, J] = W(w), N = n.forwardRef(
  (e, s) => {
    const {
      __scopeCheckbox: t,
      name: o,
      checked: h,
      defaultChecked: r,
      required: d,
      disabled: a,
      value: f = "on",
      onCheckedChange: b,
      form: p,
      ...v
    } = e, [l, C] = n.useState(null), y = z(s, (c) => C(c)), _ = n.useRef(!1), E = l ? p || !!l.closest("form") : !0, [m = !1, P] = K({
      prop: h,
      defaultProp: r,
      onChange: b
    }), D = n.useRef(m);
    return n.useEffect(() => {
      const c = l == null ? void 0 : l.form;
      if (c) {
        const x = () => P(D.current);
        return c.addEventListener("reset", x), () => c.removeEventListener("reset", x);
      }
    }, [l, P]), /* @__PURE__ */ g($, { scope: t, state: m, disabled: a, children: [
      /* @__PURE__ */ i(
        I.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": u(m) ? "mixed" : m,
          "aria-required": d,
          "data-state": H(m),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: f,
          ...v,
          ref: y,
          onKeyDown: R(e.onKeyDown, (c) => {
            c.key === "Enter" && c.preventDefault();
          }),
          onClick: R(e.onClick, (c) => {
            P((x) => u(x) ? !0 : !x), E && (_.current = c.isPropagationStopped(), _.current || c.stopPropagation());
          })
        }
      ),
      E && /* @__PURE__ */ i(
        Q,
        {
          control: l,
          bubbles: !_.current,
          name: o,
          value: f,
          checked: m,
          required: d,
          disabled: a,
          form: p,
          style: { transform: "translateX(-100%)" },
          defaultChecked: u(r) ? !1 : r
        }
      )
    ] });
  }
);
N.displayName = w;
var O = "CheckboxIndicator", B = n.forwardRef(
  (e, s) => {
    const { __scopeCheckbox: t, forceMount: o, ...h } = e, r = J(O, t);
    return /* @__PURE__ */ i(X, { present: o || u(r.state) || r.state === !0, children: /* @__PURE__ */ i(
      I.span,
      {
        "data-state": H(r.state),
        "data-disabled": r.disabled ? "" : void 0,
        ...h,
        ref: s,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
B.displayName = O;
var Q = (e) => {
  const { control: s, checked: t, bubbles: o = !0, defaultChecked: h, ...r } = e, d = n.useRef(null), a = q(t), f = T(s);
  n.useEffect(() => {
    const p = d.current, v = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(v, "checked").set;
    if (a !== t && C) {
      const y = new Event("click", { bubbles: o });
      p.indeterminate = u(t), C.call(p, u(t) ? !1 : t), p.dispatchEvent(y);
    }
  }, [a, t, o]);
  const b = n.useRef(u(t) ? !1 : t);
  return /* @__PURE__ */ i(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: h ?? b.current,
      ...r,
      tabIndex: -1,
      ref: d,
      style: {
        ...e.style,
        ...f,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function u(e) {
  return e === "indeterminate";
}
function H(e) {
  return u(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var U = N, V = B;
const Y = "_checkbox_1rhwe_32", Z = "_shouldHighlightOnChecked_1rhwe_32", ee = "_checked_1rhwe_32", te = "_checkboxBox_1rhwe_53", oe = "_indicator_1rhwe_64", re = "_checkboxGroup_1rhwe_83", k = {
  checkbox: Y,
  shouldHighlightOnChecked: Z,
  checked: ee,
  checkboxBox: te,
  indicator: oe,
  checkboxGroup: re
}, pe = ({ children: e, className: s, label: t, ...o }) => (!t && !o["aria-label"] && !o["aria-labelledby"] && console.warn(
  "Checkbox group must provide and `aria-label` if no visible `label` prop is provided. If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility"
), // `...props` last: the type accepts every fieldset attribute, and only three were forwarded, so
// `disabled` (which should disable every control in the group), `name` and `id` were dropped. The
// two aria props are computed above from `label`, so they are spread first and then overridden
// deliberately when the caller set them and there is no visible label.
/* @__PURE__ */ g(
  "fieldset",
  {
    className: S(k.checkboxGroup, s),
    ...o,
    "aria-label": t ? void 0 : o["aria-label"],
    "aria-labelledby": t ? void 0 : o["aria-labelledby"],
    children: [
      t && /* @__PURE__ */ i("legend", { children: t }),
      e
    ]
  }
)), me = ({
  checked: e,
  children: s,
  className: t,
  onCheckedChange: o,
  shouldHighlightOnChecked: h = !0,
  ...r
}) => {
  const [d, a] = G(e), f = L();
  return M(() => {
    a(e);
  }, [e]), /* @__PURE__ */ g(
    F,
    {
      className: S(
        k.checkbox,
        {
          [k.checked]: d,
          [k.shouldHighlightOnChecked]: h
        },
        t
      ),
      "data-cxy-name": "checkbox",
      id: f,
      children: [
        /* @__PURE__ */ i(
          U,
          {
            "aria-labelledby": f,
            ...r,
            checked: d,
            className: k.checkboxBox,
            onCheckedChange: (b) => {
              o == null || o(b), a(b);
            },
            children: /* @__PURE__ */ i(V, { className: k.indicator, children: /* @__PURE__ */ i(j, { color: "blue", size: "xsm" }) })
          }
        ),
        s
      ]
    }
  );
};
export {
  me as Checkbox,
  pe as CheckboxGroup
};
